import React, { useState, useEffect } from 'react';
import { X, Star, Heart, Search, Plus, Smartphone, Check } from 'lucide-react';
import firebaseService from '../services/firebaseService';
import './ConversionPopup.css';

function ConversionPopup({ onDismiss, onSignUp }) {
  const [restroomCount, setRestroomCount] = useState(1500);
  const [userCount, setUserCount] = useState(2500);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const users = await firebaseService.getUsers();
      const restrooms = await firebaseService.getRestrooms();
      
      // Round to nearest 100
      const roundedUsers = Math.round(users.length / 100) * 100;
      const roundedRestrooms = Math.round(restrooms.length / 100) * 100;
      
      setUserCount(roundedUsers);
      setRestroomCount(roundedRestrooms);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  return (
    <div className="conversion-popup-overlay">
      <div className="conversion-popup">
        <div className="conversion-popup-content">
          <div className="conversion-popup-header">
            <h2>
              Ready to unlock <span className="highlight">The Crapper Mapper</span> community?
            </h2>
            <button 
              className="conversion-popup-close"
              onClick={onDismiss}
              aria-label="Close popup"
            >
              <X size={24} />
            </button>
          </div>
          
          <div className="conversion-popup-body">
            <div className="conversion-popup-icon">
              <span className="poo-emoji">💩</span>
            </div>
            <p className="conversion-popup-text">
              You've seen how <span className="highlight">The Crapper Mapper</span> helps you find clean restrooms. Create a free account to unlock the full experience:
            </p>
            
            <ul className="conversion-popup-features">
              <li>
                <Star size={18} className="feature-icon" />
                <div className="feature-content">
                  <strong>Thousands of Real Reviews</strong>
                  <span>See what the community is saying with details ratings and tips.</span>
                </div>
              </li>
              <li>
                <Heart size={18} className="feature-icon" />
                <div className="feature-content">
                  <strong>Save Your Favorites</strong>
                  <span>Save your go-to restrooms and access them anytime, anywhere.</span>
                </div>
              </li>
              <li>
                <Search size={18} className="feature-icon" />
                <div className="feature-content">
                  <strong>Search for Specific Amenities</strong>
                  <span>Find exactly what you need - from changing tables to accessibility options.</span>
                </div>
              </li>
              <li>
                <Plus size={18} className="feature-icon" />
                <div className="feature-content">
                  <strong>Add & Review Restrooms</strong>
                  <span>Help others by adding new locations and sharing your reviews.</span>
                </div>
              </li>
              <li>
                <Smartphone size={18} className="feature-icon" />
                <div className="feature-content">
                  <strong>Access on All Your Devices</strong>
                  <span>Use your account on the web, iOS and Android.</span>
                </div>
              </li>
            </ul>
            
            <div className="conversion-popup-stats">
              <div className="stat">
                <span className="stat-number">{restroomCount.toLocaleString()}+</span>
                <span className="stat-label">RESTROOMS REVIEWED</span>
              </div>
              <div className="stat">
                <span className="stat-number">{userCount.toLocaleString()}+</span>
                <span className="stat-label">USERS AND GROWING</span>
              </div>
              <div className="stat">
                <span className="stat-number">FREE</span>
                <span className="stat-label">TO JOIN</span>
              </div>
            </div>
          </div>
          
          <div className="conversion-popup-footer">
            <button 
              className="conversion-popup-btn primary"
              onClick={onSignUp}
            >
              Create Free Account!
            </button>
            <button 
              className="conversion-popup-link"
              onClick={onDismiss}
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConversionPopup;
